import { useNavigate } from "react-router-dom";
import { BigAddIcon } from "../../ui/icons/BigAddIcon";
import { BigDownloadIcon } from "../../ui/icons/BigDownloadIcon";
import { BigMagnifyingIcon } from "../../ui/icons/BigMagnifyingIcon";
import { Layout } from "../../ui/layout";
import { MenuItems } from "../../ui/organisms/navbar/dto";
import { MenuBox } from "./components/menuBox";
import { AssignmentList } from "./list";
import Button from "../../ui/molecules/button";
import { SelectCustom } from "../../ui/molecules/select";
import { useEffect, useState } from "react";
import { OptionType, yearOptions } from "../../utils";
import { useAppDispatch, useAppSelector } from "../../lib/redux/hooks";
import { GetAllAssignment, resetAssignmentFilters, setAssignmentFilterInspectorCode, setAssignmentFilterYear } from "./slice";
import { GetAllPersonalManagement, resetGetAllPersonalManagementResourcesStatus } from "../gestionePersonale/slice";
import { GetByIdAnagraphic, resetGetByIdStatus } from "../gestionePersonale/boxAnagrafica/slice";

export function Incarichi() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const assignmentState = useAppSelector(state => state.assignment)
    const personalManagementState = useAppSelector(state => state.personalManagement)
    const pmAnagraficaState = useAppSelector(state => state.PMAnagrafica)
    const [inspectors, setInspectors] = useState<OptionType[]>([])
    const [inspToSearch, setInspToSearch] = useState<string[]>([])

    useEffect(() => {
        dispatch(GetAllPersonalManagement({
            itemsPerPage: 0,
            page: 0,
            function: 'PERSONALE_ISPETTIVO',
            active: true
        }))
    }, [])

    useEffect(() => {
        if (personalManagementState.getAllPersonalManagementResourcesStatus === 'successfully' &&
            personalManagementState.getAllPersonalManagementResourcesResponse !== undefined
        ) {
            dispatch(resetGetAllPersonalManagementResourcesStatus())
            const inspectorsIds = personalManagementState.getAllPersonalManagementResourcesResponse.data.map(pm => String(pm.anagraphicId))
            setInspToSearch(inspectorsIds)
        }
    }, [personalManagementState.getAllPersonalManagementResourcesStatus])

    useEffect(() => {
        if (inspToSearch.length > 0) {
            dispatch(GetByIdAnagraphic(inspToSearch[0]))
        }
    }, [inspToSearch])

    useEffect(() => {
        if (pmAnagraficaState.GetByIdAnagraphicStatus === 'successfully' &&
            pmAnagraficaState.getByIdAnagraphicRequest !== undefined
        ) {
            dispatch(resetGetByIdStatus('idle'))
            const data = pmAnagraficaState.getByIdAnagraphicRequest
            const currInspectors = [...inspectors]
            currInspectors.push({
                value: data.identifierCode,
                label: `${data.name} ${data.surname} (${data.identifierCode})`
            } as OptionType)

            setInspectors(currInspectors)
            setInspToSearch(inspToSearch.slice(1))
        }
    }, [pmAnagraficaState.GetByIdAnagraphicStatus])

    return (
        <Layout menuItem={MenuItems.USERS} breadcrumbItems={['Dashboard', 'Gestione Controllo', 'Incarichi']}
            noPaddingLat
            headerLabel="Lista Incarichi"
            headerChildren={
                <div className="flex items-center h-[100%] w-[100%] justify-end" style={{ justifyContent: 'end' }}>
                    <Button size={"sm"} iconPosition={"off"} variant={"solid"} label="Crea nuovo" color={"orange"}
                        onClick={() => {
                            navigate('/inserisciIncarico')
                        }}
                    />
                </div>
            }
        >
            {/* FILTERS */}
            <div className="w-[80%] flex flex-col gap-[16px] filter" style={{ padding: '24px 24px 0px 24px' }}>
                <div style={{ display: 'flex', flex: 'wrap', gap: '24px' }}>
                    <div style={{ flex: '0.33' }}>
                        <div className='text-left assignment-text-bold'>
                            Anno
                        </div>
                        <SelectCustom
                            key={assignmentState.assignmentFilters.year || 'default'}
                            placeholder={'Anno'}
                            value={assignmentState.assignmentFilters.year}
                            options={yearOptions}
                            onChange={(value) => dispatch(setAssignmentFilterYear(value))}

                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <div className='text-left assignment-text-bold'>
                            Ispettore attivo
                        </div>
                        <SelectCustom
                            key={assignmentState.assignmentFilters.inspectorCode || 'default'}
                            defaultValue={assignmentState.assignmentFilters.inspectorCode}
                            placeholder='Seleziona ispettore...'
                            options={inspectors}
                            value={assignmentState.assignmentFilters.inspectorCode}
                            onChange={(value) => dispatch(setAssignmentFilterInspectorCode(value))}
                        />
                    </div>

                    <div style={{ alignSelf: 'flex-end' }}>
                        <Button
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"link"}
                            label="Pulisci"
                            color={"gray"}
                            onClick={() => dispatch(resetAssignmentFilters())}
                        />
                    </div>

                    <div style={{ flex: '0.2', alignSelf: 'flex-end' }}>
                        <Button
                            disabled={assignmentState.assignmentFilters.year === undefined || assignmentState.assignmentFilters.inspectorCode === undefined}
                            size={"lg"}
                            iconPosition={"off"}
                            variant={"outline"}
                            label="Cerca"
                            color={"blue"}
                            onClick={() => dispatch(GetAllAssignment(assignmentState.assignmentFilters))}
                        />
                    </div>
                </div>
            </div>
            <AssignmentList />
        </Layout>
    )
}